import React from 'react';
import CreditCardFormSection from './CreditCardFormSection';
import Takanon from '../Takanon';
import { usePermitRequestContext } from '../../../../contexts/PermitRequestContext';
import PersonDetailsFormSection from './PersonDetailsFormSection';
import CarDetailsFormSection from './CarDetailsFormSection';
import ContactDetailsFormSection from './ContactDetailsFormSection';
import AdditionalAddressFormSection from './AdditionalAddressFormSection';
import ExtraFileFormSection from './extraFiles/ExtraFileFormSection';
import { SendFill } from 'react-bootstrap-icons';
import FormHr from './FormHr';
import FormSection from './FormSection';
import addRequestPageLang from '../../../../data/lang/add-request-page.lang';
import { useTags } from '../../../../hooks/useTags';
import Button from '../../../../components/buttons/Button';


const PermitRequestForm = () => {

    const { handlePreSendPermitRequest } = usePermitRequestContext();

    const sendBtnTag = useTags()(addRequestPageLang, 'send-form-btn');


    return (
        <form style={{ display: 'flex', flexDirection: 'column', rowGap: '2rem' }}>
            <PersonDetailsFormSection />
            <CarDetailsFormSection />
            <ContactDetailsFormSection />
            <AdditionalAddressFormSection />
            <ExtraFileFormSection />
            <CreditCardFormSection />

            <FormHr widthPercentage={70} possition='left' />

            <FormSection>

                <Takanon />

                <div className='row'>
                    <div className='col-12 col-lg-3'>
                        <Button text={sendBtnTag} endIcon={<SendFill style={{ rotate: '270deg' }} />}
                            theme='success' size='lg' onClick={handlePreSendPermitRequest} />
                    </div>
                </div>
            </FormSection>

        </form>
    );
}

export default PermitRequestForm;